import {createFundamentalType, registerFundamentalNode} from "#template/fundamental/factory"
import {ObjectInfo} from "#template/interface-descriptors"
import {objectMarker} from "#template/nodes/object/marker"

export {isObjectLikeNode, isObjectLikeNodeClass, objectLike, objectLikeMarker} from "#template/nodes/object/marker"
export type {ObjectLikeNode} from "#template/nodes/object/marker"

export const ObjectFT = createFundamentalType({
    name: "Object",
    marker: objectMarker,
    InfoClass: ObjectInfo,
    icon: "far fa-cube",
})

@registerFundamentalNode(ObjectFT, "Likes")
export class ObjectLikes extends ObjectFT.Likes {}

@registerFundamentalNode(ObjectFT, "Switch")
export class ObjectSwitch extends ObjectFT.Switch {}

@registerFundamentalNode(ObjectFT, "Input")
export class ObjectInput extends ObjectFT.Input {}

@registerFundamentalNode(ObjectFT, "Output")
export class ObjectOutput extends ObjectFT.Output {}

@registerFundamentalNode(ObjectFT, "Export")
export class ObjectExport extends ObjectFT.Export {}
